import {
  ADD_FORM_BUILDER,
  ADD_FORM_BUILDER_FAILED,
  ADD_FORM_BUILDER_SUCCESS,
  DELETE_FORM_BUILDER,
  DELETE_FORM_BUILDER_FAILED,
  DELETE_FORM_BUILDER_SUCCESS,
  GET_FORM_BUILDER,
  GET_FORM_BUILDER_FAILED,
  GET_FORM_BUILDER_LIST,
  GET_FORM_BUILDER_LIST_FAILED,
  GET_FORM_BUILDER_LIST_SUCCESS,
  GET_FORM_BUILDER_REPLY,
  GET_FORM_BUILDER_REPLY_FAILED,
  GET_FORM_BUILDER_REPLY_SUCCESS,
  GET_FORM_BUILDER_SUCCESS,
  HIDE_DELETE_FORM_BUILDER_MODAL,
  OPEN_DELETE_FORM_BUILDER_MODAL,
  REFUND_FORM_BUILDER,
  REFUND_FORM_BUILDER_FAILED,
  REFUND_FORM_BUILDER_SUCCESS,
  RESET_FORM_BUILDER,
  RESET_FORM_BUILDER_LIST,
  RESET_FORM_BUILDER_REPLY,
  UPDATE_FEATURE_RECIPIENT,
  UPDATE_FEATURE_RECIPIENT_FAILED,
  UPDATE_FEATURE_RECIPIENT_SUCCESS,
  UPDATE_FORM_BUILDER,
  UPDATE_FORM_BUILDER_FAILED,
  UPDATE_FORM_BUILDER_FEATURE,
  UPDATE_FORM_BUILDER_FEATURE_FAILED,
  UPDATE_FORM_BUILDER_FEATURE_SUCCESS,
  UPDATE_FORM_BUILDER_SUCCESS,
} from "./actionTypes"

export const addFormBuilder = (questions, params) => ({
  type: ADD_FORM_BUILDER,
  payload: { questions, params },
})

export const addFormBuilderSuccess = response => ({
  type: ADD_FORM_BUILDER_SUCCESS,
  payload: response,
})

export const addFormBuilderFailed = error => ({
  type: ADD_FORM_BUILDER_FAILED,
  payload: error,
})

export const getFormBuilder = params => ({
  type: GET_FORM_BUILDER,
  payload: params,
})

export const getFormBuilderSuccess = response => ({
  type: GET_FORM_BUILDER_SUCCESS,
  payload: response,
})

export const getFormBuilderFailed = error => ({
  type: GET_FORM_BUILDER_FAILED,
  payload: error,
})

export const resetFormBuilder = () => ({
  type: RESET_FORM_BUILDER,
  payload: {},
})

export const updateFormBuilder = (questions, params, entity_id) => ({
  type: UPDATE_FORM_BUILDER,
  payload: { questions, params, entity_id },
})

export const updateFormBuilderSuccess = response => ({
  type: UPDATE_FORM_BUILDER_SUCCESS,
  payload: response,
})

export const updateFormBuilderFailed = error => ({
  type: UPDATE_FORM_BUILDER_FAILED,
  payload: error,
})

export const getFormBuilderList = params => ({
  type: GET_FORM_BUILDER_LIST,
  payload: params,
})

export const getFormBuilderListSuccess = response => ({
  type: GET_FORM_BUILDER_LIST_SUCCESS,
  payload: response,
})

export const getFormBuilderListFailed = error => ({
  type: GET_FORM_BUILDER_LIST_FAILED,
  payload: error,
})

export const resetFormBuilderList = () => ({
  type: RESET_FORM_BUILDER_LIST,
  payload: {},
})

export const updateFormBuilderFeature = params => ({
  type: UPDATE_FORM_BUILDER_FEATURE,
  payload: params,
})

export const updateFormBuilderFeatureSuccess = response => ({
  type: UPDATE_FORM_BUILDER_FEATURE_SUCCESS,
  payload: response,
})

export const updateFormBuilderFeatureFailed = error => ({
  type: UPDATE_FORM_BUILDER_FEATURE_FAILED,
  payload: error,
})

export const openDeleteFormBuilderModal = () => ({
  type: OPEN_DELETE_FORM_BUILDER_MODAL,
  payload: {},
})

export const hideDeleteFormBuilderModal = () => ({
  type: HIDE_DELETE_FORM_BUILDER_MODAL,
  payload: {},
})

export const deleteFormBuilder = params => ({
  type: DELETE_FORM_BUILDER,
  payload: params,
})

export const deleteFormBuilderSuccess = response => ({
  type: DELETE_FORM_BUILDER_SUCCESS,
  payload: response,
})

export const deleteFormBuilderFailed = error => ({
  type: DELETE_FORM_BUILDER_FAILED,
  payload: error,
})

export const updateFeatureRecipient = params => ({
  type: UPDATE_FEATURE_RECIPIENT,
  payload: params,
})

export const updateFeatureRecipientSuccess = response => ({
  type: UPDATE_FEATURE_RECIPIENT_SUCCESS,
  payload: response,
})

export const updateFeatureRecipientFailed = error => ({
  type: UPDATE_FEATURE_RECIPIENT_FAILED,
  payload: error,
})

export const getFormBuilderReply = params => ({
  type: GET_FORM_BUILDER_REPLY,
  payload: params,
})

export const getFormBuilderReplySuccess = response => ({
  type: GET_FORM_BUILDER_REPLY_SUCCESS,
  payload: response,
})

export const getFormBuilderReplyFailed = error => ({
  type: GET_FORM_BUILDER_REPLY_FAILED,
  payload: error,
})

export const resetFormBuilderReply = () => ({
  type: RESET_FORM_BUILDER_REPLY,
  payload: {},
})

export const refundFormBuilder = params => ({
  type: REFUND_FORM_BUILDER,
  payload: params,
})

export const refundFormBuilderSuccess = response => ({
  type: REFUND_FORM_BUILDER_SUCCESS,
  payload: response,
})

export const refundFormBuilderFailed = error => ({
  type: REFUND_FORM_BUILDER_FAILED,
  payload: error,
})
